__turbopack_context__.v({
  "content_metadata": "ZTOEHq_content_metadata",
  "content_metadata__follow_us": "ZTOEHq_content_metadata__follow_us",
  "content_metadata__genre": "ZTOEHq_content_metadata__genre",
  "content_metadata__genre_badges": "ZTOEHq_content_metadata__genre_badges",
  "content_metadata__rating": "ZTOEHq_content_metadata__rating",
  "content_metadata__share_this_video": "ZTOEHq_content_metadata__share_this_video",
  "content_metadata__share_this_video__links": "ZTOEHq_content_metadata__share_this_video__links",
  "content_metadata__share_this_video__links__embed_button": "ZTOEHq_content_metadata__share_this_video__links__embed_button",
  "content_metadata__social_stuff": "ZTOEHq_content_metadata__social_stuff",
  "content_metadata__sub_title": "ZTOEHq_content_metadata__sub_title",
  "content_metadata__title": "ZTOEHq_content_metadata__title",
});
